import { useState, useRef, useEffect } from 'react'

export function useRocketKanbanScroll(deps: unknown[]) {
  const containerRef = useRef<HTMLDivElement>(null)
  const [showLeft, setShowLeft] = useState(false)
  const [showRight, setShowRight] = useState(false)

  const checkScroll = () => {
    if (!containerRef.current) return
    const { scrollLeft, scrollWidth, clientWidth } = containerRef.current
    setShowLeft(scrollLeft > 20)
    setShowRight(scrollLeft < scrollWidth - clientWidth - 20)
  }

  useEffect(() => {
    checkScroll()
    window.addEventListener('resize', checkScroll)
    return () => window.removeEventListener('resize', checkScroll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  const scroll = (dir: 'left' | 'right') => {
    if (!containerRef.current) return
    const amount = containerRef.current.clientWidth * 0.6
    containerRef.current.scrollBy({ left: dir === 'left' ? -amount : amount, behavior: 'smooth' })
  }

  return { containerRef, showLeft, showRight, checkScroll, scroll }
}
